import type { FaireProductEntity } from "../../entity_types/product";

export const p_8azzac2ram: FaireProductEntity = {
  token: "p_8azzac2ram",
  type: "product",
  name: "Moissanite Star Wedding Band Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/a538df6b0b7155b08787644db38040eb98a96b80968120e813f5b070550a2701.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3dd0fd3ee7127c7fd0c73c89f9d938706d558f0ac7cc3f7546d0230516825e77.jpeg",
    "https://cdn.faire.com/fastly/5d43ceb1197a7346efda9efed2afebadde7d40e092f437d8326f7cbe8855d292.jpeg",
    "https://cdn.faire.com/fastly/21002472af479d36f7efb8c6b429d6c7a5958b99997a275e047365e257f593da.jpeg",
    "https://cdn.faire.com/fastly/bb938b282fb9f0d3cc5d5a6c599d691bbef8fd1155074e4dccd88a5b0dfac43a.jpeg",
  ],
  priceDollars: 47.77,
  description:
    "Description & Details\n\nExperience the brilliance and beauty of this exceptional gemstone. Each piece in our collection is meticulously crafted to showcase the mesmerizing sparkle and fire of moissanite, offering a stunning alternative to traditional diamond jewelry.\n\n• Material: Solid 925 Sterling Silver ∙ Certified Moissanite (Color D, VVS1)\n• Finish: Hypoallergenic ∙ 950 Platinum (Pt 950) Plating\n• Dimensions: 0.11 ct, Color D, VVS1 Moissanite, US size 5 - 10 available\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 95.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:54.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
